module.exports = __webpack_public_path__ + "img/parallax.1de29875.jpg";